<template>
  <WithLoader :isLoading="!identityLoaded" classType="primary">
    <div class="page">
      <component :title="title" :is="layout" :extraClass="extraClass">
        <router-view
          :layout.sync="layout"
          :layoutTitle.sync="title"
          :extraClass.sync="extraClass"
        ></router-view>
      </component>
      <div id="root"></div>
    </div>
  </WithLoader>
</template>

<script>
import "reset.css";
import "animate.css";
import { mapActions } from "vuex";
import WithLoader from "@/components/WithLoader";
import withNavigate from "@/mixins/withNavigate";

// favicons
import favicon from "@/assets/images/favicons/favicon.png";
import faviconGreen from "@/assets/images/favicons/favicon-green.png";

import { beamerCode } from "./config.js";

const BEAMER_SCRIPT_URL = "https://app.getbeamer.com/js/beamer-embed.js";

export default {
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Inkit",
    // all titles will be injected into this template
    titleTemplate: "%s - Inkit",
    link: [
      {
        rel: "favicon",
        href: window.location.hostname.includes("development")
          ? faviconGreen
          : favicon,
        type: "image/png"
      }
    ]
  },

  data() {
    return {
      layout: "div",
      title: null,
      extraClass: ""
    };
  },

  components: {
    WithLoader
  },

  mixins: [withNavigate],

  methods: {
    /**
     * Helper for injection script into head of html
     * @param data - whether src of script or content if the type is content
     * @param type - content or source
     * @private
     */
    _injectScript(data, type = "source") {
      const script = document.createElement("script");

      if (type === "source") {
        script.async = true;
        script.setAttribute("src", data);
      } else if (type === "content") {
        script.textContent = data;
      }

      document.head.appendChild(script);
      script.remove();
    },

    _injectBeamerScript(user) {
      const { first_name, last_name, email, id } = user;

      const beamerScriptString = `(${function(
        product_id,
        user_firstname,
        user_lastname,
        user_email,
        user_id
      ) {
        window.beamer_config = {
          product_id,

          // visitor info
          user_firstname,
          user_lastname,
          user_email,
          user_id
        };
      }})('${beamerCode}', '${first_name}', '${last_name}', '${email}', '${id}');`;

      this._injectScript(beamerScriptString, "content");
      this._injectScript(BEAMER_SCRIPT_URL);
    },

    ...mapActions("account", ["fetchIdentity"]),
    ...mapActions("billing", ["fetchCreditCards", "fetchBankAccounts"]),
    ...mapActions("user", ["fetchGravatar"])
  },

  computed: {
    identity() {
      return this.$store.state.account.identity;
    },

    identityLoaded() {
      return this.$store.state.account.identityLoaded;
    }
  },

  mounted() {
    this.fetchIdentity();
  },

  watch: {
    identity: function(identityObj) {
      const { account } = identityObj;

      if (account) {
        // if no payment and not billing info filled by user
        // that means that signup is not finished
        if (!account.active_payment && !account.information_filled) {
          this.replace("/signup");
        } else if (!account.active_payment) {
          this.replace("/payment");
        }
      }
    }
  }
};
</script>

<style lang="scss" src="./styles/main.scss"></style>
